import "./fonts.css";
import "./App.css";

import { Routes, Route, useNavigate, Link } from "react-router-dom";
import Navbar from "./components/Navbar";
import ErrorPage from "./components/ErrorPage";
import { useEffect, useState } from "react";
import Header from "./components/Header";
import SearchForm from "./components/search/SearchForm";
import FilterForm from "./components/search/FilterForm";
import GenrePage from "./components/ByGenre/GenrePage";
import Footer from "./components/Footer";
import AllMovies from "./components/AllMovies";
import CarouselMovies from "./components/CarouselMovies";
import MovieWatch from "./components/MovieWatch";
import axios from "axios";
import MoviePage from "./components/MoviePage";
import CircularProgress from "@mui/material/CircularProgress";
const key = "b55d580200c51623fe9608f8f064a09b";

function App() {
  const navigate = useNavigate();

  // Get genres:
  const [movieGenres, setMovieGenres] = useState("");
  useEffect(() => {
    const getGenres = async () => {
      const response = await axios.get(
        `https://api.themoviedb.org/3/genre/movie/list?api_key=${key}&language=en-US`
      );
      setMovieGenres(response.data);
    };
    getGenres();
  }, []);

  return (
    <div className="App">
      <Navbar />
      <div className="all">
        <Routes>
          <Route
            path="/"
            element={
              movieGenres === "" ? (
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{ width: "100%", height: "100vh" }}
                >
                  <CircularProgress color="secondary" />
                </div>
              ) : (
                <>
                  <Header />

                  {movieGenres.genres.map((genre) => {
                    return (
                      <div
                        className="genre-section-container my-4 "
                        key={genre.id}
                      >
                        <div className="title-genre d-flex align-items-baseline">
                          <Link
                            to={`/genre/${genre.id}`}
                            style={{ textDecoration: "none" }}
                            className="genreLink ms-2 mb-2 mt-0 pt-0 "
                          >
                            <h3 className="genreTitle text-start mb-0 ">
                              {genre.name}
                            </h3>
                          </Link>
                          <span className="i-span">
                            <i className="ms-1 fa-solid fa-play "></i>
                            {/* <i className=" ms-1 fa-solid fa-arrow-right fa-sm"></i> */}
                          </span>
                        </div>
                        <CarouselMovies genreId={genre.id} />
                      </div>
                    );
                  })}
                </>
              )
            }
          />

          <Route path="/pelicula/:id" element={<MoviePage />} />
          <Route
            path="/showall"
            element={
              <>
                <div style={{ width: "100%", height: " 33px" }}></div>
                <h1
                  // className="pt-5 mb-4 muted-title fs-1"
                  className="genreTitle text-start ms-3 pt-5 mb-4  fs-1 "
                >
                  All our movies:
                </h1>
                <hr className=" my-4" />
                <AllMovies />
              </>
            }
          />
          <Route
            path="/about"
            element={
              <>
                <h1 className="py-5">Sobre Nosotros</h1>
                <h1 className="my-5 text-light fw-bold">
                  Espacio en construcción
                </h1>
              </>
            }
          />
          <Route
            path="/contact"
            element={
              <>
                <h1 className="py-5">Contacto</h1>
                <h1 className="my-5 text-light fw-bold">
                  Espacio en construcción
                </h1>
              </>
            }
          />
          <Route path="/search/title" element={<SearchForm />} />
          <Route path="/search/rating" element={<FilterForm />} />
          <Route path="/watch/:id" element={<MovieWatch />} />
          <Route path="/genre/:id" element={<GenrePage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>

        <Footer />
      </div>
    </div>
  );
}

export default App;
